import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { ListItemText } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import { List } from '@material-ui/core';
import { ListItemIcon } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { Edit as EditIcon } from '@material-ui/icons';
import { Person as PersonIcon } from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { EmployeeDto } from './userTypes';
import NewEmployeesDialog from './NewEmployeesDialog';
import { ListItemSecondaryAction } from '@material-ui/core';
import EditEmployeeDialog from './EditEmployeeDialog';
import { observer } from 'mobx-react';
import { IObservableObject, IObservableValue, observable } from 'mobx';
import { Paper } from '@material-ui/core';
import { getEmployees } from './userApi';
import { defaultPageable, Pageable } from '../../api/pageable';
import PaginationNavigation from '../../components/PaginationNavigation';
import EmptyPage from '../../components/emptyPage/EmptyPage';
import { translation } from '../../i18n';
import { withEmployeePage } from '../../router/Loaders';
import { Fab } from '@material-ui/core';

interface Props {
  renderSearch: (showSearch: boolean) => void;
  searchText: IObservableValue<string>;
}

type LocalStyles = 'root' | 'button';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class Employees extends React.Component<PropsWithStyle> {

  private openNewEmployee: IObservableValue<boolean> = observable.box(false);
  private openEditEmployee: IObservableValue<boolean> = observable.box(false);
  private keyCounter: IObservableValue<number> = observable.box(0);
  @observable private employee: EmployeeDto & IObservableObject;
  @observable private pageAble: Pageable = defaultPageable();

  constructor(props: PropsWithStyle) {
    super(props);
    this.onCloseNewEmployeeDialog = this.onCloseNewEmployeeDialog.bind(this);
    this.onCloseEditEmployeeDialog = this.onCloseEditEmployeeDialog.bind(this);

    this.props.renderSearch(true);
  }

  public render() {
    const {classes} = this.props;
    return (
      <>
        {
          withEmployeePage(
            () =>  getEmployees({searchText: this.props.searchText.get()}, this.pageAble),
            'withPage' + this.pageAble.page + this.props.searchText + this.keyCounter.get(),
            employeePage =>
              <>
                {employeePage.content.length === 0 ?
                  <EmptyPage message={translation.t('noEntry.employees.title')}
                             searchText={this.props.searchText.get()}
                             onFabClicked={this.onNewEmployeeClicked}
                             displayFab={true}/> :
                  <Paper elevation={1} className={this.props.classes.root}>
                    <List>
                      {employeePage.content.map(value => (
                        <ListItem
                          key={value.id}
                        >
                          <ListItemIcon>
                            <PersonIcon/>
                          </ListItemIcon>
                          <ListItemText primary={`${value.firstName} ${value.lastName}`} secondary={`${value.email}`}/>
                          <ListItemSecondaryAction>
                            <Button onClick={() => this.onEditEmployeeClicked(value)}>
                              <EditIcon/>
                            </Button>
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))}
                    </List>
                    <PaginationNavigation
                      totalPages={employeePage.totalPages}
                      page={employeePage.pageable.pageNumber!!}
                      onChangePage={this.handleChangePage}/>

                    <Fab color="primary" arial-label="Add" className={classes.button} onClick={this.onNewEmployeeClicked}>
                      <AddIcon/>
                    </Fab>

                  </Paper>
                }
              </>
          )
        }
        <NewEmployeesDialog
          open={this.openNewEmployee.get()}
          onClose={this.onCloseNewEmployeeDialog}
          onSave={this.createNewEmployee}
        />

        <EditEmployeeDialog
          onClose={this.onCloseEditEmployeeDialog}
          onSave={this.updateEmployee}
          open={this.openEditEmployee.get()}
          user={this.employee}/>
      </>
    );
  }

  private handleChangePage = (event: any, page: number) => {
    this.pageAble.page = page;
  };

  private onNewEmployeeClicked = () => {
    this.openNewEmployee.set(true);
  };

  private createNewEmployee = () => {
    this.onCloseNewEmployeeDialog();
    this.keyCounter.set(this.keyCounter.get() + 1);
  };

  private onEditEmployeeClicked = (employee: EmployeeDto) => {
    this.employee = observable({...employee});
    this.openEditEmployee.set(true);
  };

  private updateEmployee = () => {
    this.onCloseEditEmployeeDialog();
    this.keyCounter.set(this.keyCounter.get() + 1);
  };

  private readonly onCloseNewEmployeeDialog = () => {
    this.openNewEmployee.set(false);
  };

  private readonly onCloseEditEmployeeDialog = () => {
    this.openEditEmployee.set(false);
  }
}

export default withStyles(localStyles)(Employees);
